import { defineComponent as _defineComponent } from 'vue'
import { BaseComponent } from '@tencent/wphk-components-content-loader';
import Container from './components/container.vue';
import Footer from './components/footer.vue';
import ModuleSkeleton from './components/module-skeleton.vue';
import { BasicCouponV2 } from '@tencent/wphk-act-base-components';
import { useBankAct } from './hooks/use-bank-act';
import { showLoading, hideLoading } from '@tencent/wphk-components-loading';
import { to } from '@tencent/wphk-base-utils';
import { CouponActInfoWithGoodsAndState } from '@tencent/wphk-act-base-framework';
import { showBusinessError } from '@tencent/wphk-components-dialog';
import { CustomException } from '@tencent/ppd-base-libs';
import { ExecActState } from '@tencent/wphk-act-base-cgi';
import { useExchUIInfo } from './hooks/use-exch-ui-info';
import { goCouponDetail } from '@tencent/wphk-components-jump-page/src/jump-page';
import { showToast } from '@tencent/wphk-components-toast';
import { useGlobalBi } from '@/hooks/use-global-bi';
import { biClick } from '@tencent/fit-bi-sdk';
import { ExchButtonStatus } from '@/types/exch-info';
import { useExchInfo } from '@/hooks/use-exch-info';

// ---- hooks ----

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const {
  isHideModule,
  isReady,
  title,
  bgImg,
  tag,
  tncUrl,
  couponInfo,
  imgUrlList,

  receiveCoupon,
  updateCoupon,
} = useBankAct();
const { getBiExt } = useGlobalBi();

// 业务定制化参数
function selfDefineAttr(item: CouponActInfoWithGoodsAndState) {
  const { couponExtraInfo } = useExchUIInfo({ exchInfo: item, extraInfo: { isLocked: false } });
  return {
    ...couponExtraInfo,
    couponTagText: tag.value,
  };
}

const getExtraBiExt = (item: CouponActInfoWithGoodsAndState) => ({ ...getBiExt(), fcouponName: item.couponName! });

function handleCouponBtnClick(item: CouponActInfoWithGoodsAndState) {
  biClick('bank-act-module.coupon-btn-click|点击btn', getExtraBiExt(item));
  console.log('===handleCouponBtnClick', item);
  const { exchButtonStatus } = useExchInfo({ exchInfo: item });
  if (exchButtonStatus === ExchButtonStatus.ToReceive) {
    doReceiveCoupon(item);
    biClick('bank-act-module.coupon-receive|领券', getExtraBiExt(item));
  } else if (exchButtonStatus === ExchButtonStatus.ToUse) {
    goCouponDetail({ userScid: item.userCouponid!, adtag: 'channel-bankact' });
    biClick('bank-act-module.coupon-2use|去用券', getExtraBiExt(item));
  }
}

// ---- 辅助方法 ----
async function doReceiveCoupon(couponInfo: CouponActInfoWithGoodsAndState) {
  const { enActid = '', prizeId } = couponInfo;
  // 领券
  showLoading();
  const [err] = await to(receiveCoupon({
    actListid: enActid,
    prizeId,
  }));
  hideLoading();
  if (!err) {
    // 领取成功提示
    showToast({
      title: '領取成功',
      duration: 1000,
    });
  } else {
    showBusinessError(err);
    const { options } = (err as any);
    const execState = options?.execState;
    new CustomException(err, 'BankActException', `get coupon fail. execState: ${execState}`);
  }
  // 成功，更新状态
  const [err2] = await to(updateCoupon());
  if (err2) {
    // 不提示
    throw new CustomException(err2, 'BankActUpdateException', 'update coupon fail');
  }
}

return { __sfc: true,isHideModule, isReady, title, bgImg, tag, tncUrl, couponInfo, imgUrlList, receiveCoupon, updateCoupon, getBiExt, selfDefineAttr, getExtraBiExt, handleCouponBtnClick, doReceiveCoupon, BaseComponent, Container, Footer, ModuleSkeleton, BasicCouponV2 }
}

})